$("document").ready(async() => {
  const urlApiInitial = $("#urlApiInitial").attr("href");
  let url = `${urlApiInitial}/states`;
  $.ajax({
    type: "GET",
    url: url,
    headers: {
      "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
    },
    success: function(data) {
      let states = data.data;
      let optionHtmlState =
        "<option selected disabled> Seleccione el estado: </option>";
      if (states) {
        states.forEach((element) => {
          optionHtmlState += `<option value="${element.id}">${element.name}</option>`;
        });
        $("#state_id").html(optionHtmlState);
        $("#state_id").attr("disabled", false);
      } else {
        $("#state_id").html("<option selected disabled>No exists</option>");
        $("#state_id").attr("disabled", true);
      }
    },
  });
});
